'use strict';
(function () {
  angular.module('pentaApp').factory('qrCode.resource', service);

  service.$inject = ['$resource'];
  function service($resource) {
    return $resource('/progressiveApp/api/qrCode', {}, {
      create: {
        method: 'POST',
        isArray: false
      }
    });
  }
})();